import React from 'react';

// EL FONDO DE FOTOS DEL CUESTIONARIO (20-10, sustituye al disco de pesas que había, también
// en «Pago realizado correctamente», que lleva la primera).
// Ocho fotos del gimnasio (docs/diseño/fondos cuestionario, pasadas a WebP en
// public/fondos-cuestionario), EN ORDEN y CADA CUATRO PANTALLAS: las pantallas 0-3 llevan la
// primera, las 4-7 la segunda... y tras la octava vuelve a empezar.
//
// MÁS APAGADAS (20-10, segunda vuelta: «destacan demasiado contra el formulario»): la foto
// se ve al 12 % (capa negra al 88 %); antes, al 22 %. Sin desenfoque: nítidas, pero tenues.
//
// Las ocho están montadas a la vez y solo la de la pantalla se ve: así se cargan de una
// vez al entrar, y al cambiar se funden en vez de parpadear mientras baja la siguiente.
// La capa ocupa lo que el padre y recorta en los dos ejes: no lo estira.
export const FOTOS_DEL_FONDO = Array.from({ length: 8 },
    (_, n) => `${process.env.PUBLIC_URL || ''}/fondos-cuestionario/fondo-${n + 1}.webp`);

const PANTALLAS_POR_FOTO = 4;

const FondoFotos = ({ pantalla = 0 }) => {
    const n = FOTOS_DEL_FONDO.length;
    const actual = ((Math.floor(pantalla / PANTALLAS_POR_FOTO) % n) + n) % n;
    return (
        <div aria-hidden="true" className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="fondo-fotos">
            {FOTOS_DEL_FONDO.map((src, i) => (
                <div key={src} className="absolute inset-0 bg-cover bg-center transition-opacity duration-700"
                    style={{ backgroundImage: `url("${src}")`, opacity: i === actual ? 1 : 0 }} />
            ))}
            <div className="absolute inset-0 bg-black/[.88]" />
        </div>
    );
};

export default FondoFotos;
